import Vue from 'vue'

export async function getReporteMarketing(context, [access_token, params]) {
    
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/reporteMarketing',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })
            context.commit('reportes/setReporteMarketing', response.data.data, { root: true })

            if (response.status == 200 && response.data?.data) {
                return response.data.data;
            } else {
                return null;
            }
           

        }

    } catch (e) {
      console.error('Error al obtener el reporte de marketing:', e);
    } 
}

export async function getReporteMarketingAgencia(context, [access_token, params]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/reporteMarketingAgencia',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })

            const data = response.data?.data || {};
            context.commit('reportes/setReporteMarketingAgencia', data, { root: true });

            return response.status == 200 && response.data?.success ? data : null;
        }
    } catch (e) {
      console.error('Error al obtener el reporte de marketing por agencia:', e);
      return null;
    }
}

export async function getReporteMarketingAgenciaPorCamino(context, [access_token, params]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/reporteMarketingAgenciaPorCamino',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })

            const data = response.data?.data || {};
            context.commit('reportes/setReporteMarketingAgenciaPorCamino', data, { root: true });

            return response.status == 200 && response.data?.success ? data : null;
        }
    } catch (e) {
      console.error('Error al obtener el reporte de marketing por agencia y camino:', e);
      return null;
    }
}

export async function getReportePasajerosProcedencia(context, [access_token, params]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/reportePasajerosProcedencia',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })

            context.commit('reportes/setReportePasajerosProcedencia', response.data, { root: true })

            if (response.status == 200 && response.data) {
                return response.data;
            } else {
                return null;
            }
        }
    } catch (e) {
      console.error('Error al obtener el reporte de pasajeros por procedencia:', e);
    }
}

export async function getReporteAsignacionesPorTrabajador(context, [access_token, params]) {
    
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/reporteAsignacionesPorTrabajador',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })
            console.log('response', response);
            context.commit('reportes/setReporteAsignacionesPorTrabajador', response.data.data, { root: true })

            if (response.status == 200 && response.data?.data) {
                return response.data.data;
            } else {
                return null;
            }
           

        }

    } catch (e) {
      console.error('Error al obtener el reporte de marketing:', e);
    } 
}

export async function getReporteReservasAsignadasTrabajador(context, [access_token, trabajadorId]) {
    try {
        if (access_token && trabajadorId) {
            const response = await Vue.axios({
                method: 'GET',
                url: `/reporteReservasAsignadasTrabajador/${trabajadorId}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

            const data = Array.isArray(response.data?.data)
                ? response.data.data
                : (response.data?.data ? [response.data.data] : [])

            context.commit('reportes/setReporteReservasAsignadasTrabajador', data, { root: true })

            if (response.status == 200) {
                return data;
            } else {
                return [];
            }
        }

        return [];
    } catch (e) {
      console.error('Error al obtener el detalle de reservas asignadas por trabajador:', e);
      return [];
    } 
}

export async function enviarReportePorTrabajadores(context, [access_token, email]) {
    try {
        if (access_token && email) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/EnvioReportePorTrabajadores',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    email,
                }
            })

            if (response.status == 200 && response.data) {
                return response.data;
            }
        }

        return null;
    } catch (e) {
      console.error('Error al enviar el reporte por trabajadores:', e);
      throw e;
    } 
}
